<script>
	import AnswerComponent from './AnswerComponent.svelte';
	import {uqnArray} from './stores.js';
</script>

<h2>Answer</h2>
{#each $uqnArray as uqn, id}
<AnswerComponent uqn={uqn} qnNameCode={id}/>
{/each}
<hr>
